import {
  type FleetOnboardingStep,
} from "@/features/operator/fleet/fleet-onboarding-shared"
import { cn } from "@/lib/utils"

export function FleetOnboardingStepper(props: {
  activeStep: FleetOnboardingStep
}) {
  const steps: Array<{ key: FleetOnboardingStep; label: string }> = [
    { key: "overview", label: "Onboarding" },
    { key: "organization", label: "Organization" },
    { key: "import", label: "Import" },
    { key: "manual", label: "Manual Entry" },
    { key: "review", label: "Review" },
  ]

  const activeIndex = steps.findIndex((step) => step.key === props.activeStep)

  return (
    <div className="grid gap-3 md:grid-cols-5">
      {steps.map((step, index) => {
        const isActive = step.key === props.activeStep
        const isComplete = activeIndex > index

        return (
          <div
            key={step.key}
            className={cn(
              "rounded-3xl border px-4 py-3 text-sm transition-colors",
              isActive
                ? "border-primary/50 bg-primary/8"
                : isComplete
                  ? "border-emerald-300/60 bg-emerald-50/70"
                  : "border-border/70 bg-background/70"
            )}
          >
            <div className="text-[11px] uppercase tracking-[0.18em] text-muted-foreground">
              Step {index + 1}
            </div>
            <div className="mt-1 font-medium">{step.label}</div>
          </div>
        )
      })}
    </div>
  )
}
